export default defineNuxtPlugin(nuxtApp => {
    const i18n = nuxtApp.$i18n as { locale: { value: string } };
    nuxtApp.provide('dbt', (trad: Record<string, string> | null | undefined): string => {
        return trad ? trad[i18n.locale.value] || trad['fr'] : '';
    });
});
